export const AGORA_APP_ID = process.env.REACT_APP_AGORA_APP_ID;